export default {"src":"/_next/static/media/hugeicons_cleaning-bucket.9e40c3e6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};